export default __webpack_public_path__ + "static/media/icn-lock-open.7c79c9b3.svg";